import React, { useState } from "react"

interface ThemeType {
  darkMode: boolean
  setDarkMode: any
}

const defaultVal: ThemeType = {
  darkMode: false,
  setDarkMode: () => {},
}

export const ThemeContext = React.createContext<ThemeType>(defaultVal)

export default function useTheme() {
  return React.useContext(ThemeContext)
}

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [darkMode, setDarkMode] = useState(false)

  return (
    <ThemeContext.Provider
      value={{
        darkMode,
        setDarkMode,
      }}
    >
      {children}
    </ThemeContext.Provider>
  )
}
